import React from 'react';
import QuoteBase from './QuoteBase';

function QuoteControl(props) {
  return <QuoteBase {...props} />;
}

export default QuoteControl;
